import React from "react";
import { Query } from "react-apollo";
import gql from "graphql-tag";
import RecentlyViewed from "./recently-viewed";
import LoadingSpinner from "../loading-spinner/loading-spinner";
import PropTypes from "prop-types";
import { PRODUCT_CARD_FRAGMENT } from "../product-card/graphql-product-card";
import userProfiler from "modules/userprofiler";
import environment from "modules/environment";

const PRODUCTS_TO_SHOW = 10;

function getRecentlyViewedProducts(number, currentProductId) {
    // If we're on a product page we're going to exclude
    // the current product from the recently viewed module.
    if (currentProductId) {
        number++;
    }

    let seenProducts = userProfiler
        .getSeenProducts()
        .slice(-number)
        .reverse();
    let productIds = seenProducts.reduce((memo, product) => {
        if (product.productId !== currentProductId) {
            memo.push(product.productId);
        }

        return memo;
    }, []);

    return productIds;
}

export const GET_RECENTLY_VIEWED_QUERY = gql`
    query($productIds: [String]!, $country: String!, $gender: [Gender]!) {
        products(productIds: $productIds, country: $country, genders: $gender) {
            ...ProductCard
        }
    }
    ${PRODUCT_CARD_FRAGMENT}
`;

function GraphQLRecentlyViewed({ currentProductId }) {
    const country = environment.get("country");
    const gender = userProfiler.userProfile.user.gender === "M" ? ["MALE"] : ["FEMALE"];
    const productIds = getRecentlyViewedProducts(PRODUCTS_TO_SHOW, currentProductId);

    if (productIds.length === 0) {
        return false;
    }

    return (
        <Query
            query={GET_RECENTLY_VIEWED_QUERY}
            variables={{
                productIds: productIds,
                country,
                gender
            }}
        >
            {({ loading, error, data }) => {
                if (loading) {
                    return <LoadingSpinner />;
                }
                if (error) {
                    console.error(error);
                    return false;
                }
                // TODO - test strip products with no buy options (when GQL testing example added) (WEB-3270)
                // TODO - test most recent 10 products returned (as opposed to first 10) (WEB-3270)
                // TODO - test Not more than 10 products rendered (WEB-3270)
                const products = data.products.filter(productData => productData.buyOptions.length);
                if (products.length === 0) {
                    return false;
                }

                return <RecentlyViewed products={products} country={country} />;
            }}
        </Query>
    );
}

export default GraphQLRecentlyViewed;

GraphQLRecentlyViewed.propTypes = {
    currentProductId: PropTypes.string
};

GraphQLRecentlyViewed.defaultProps = {
    currentProductId: undefined
};
